export type Stadium = {
  name: string;
  slug: string;
  country: string;
  city?: string;
  aliasOf?: string; // 🔥 NEW
};

export const stadiums: Stadium[] = [
  /* ===== SIX NATIONS ===== */

  { name: "Twickenham", slug: "twickenham", country: "England", city: "London" },

  // 🔥 ALIAS (uses Twickenham data)
  {
    name: "Allianz Stadium",
    slug: "allianz-stadium",
    country: "England",
    city: "London",
    aliasOf: "twickenham",
  },

  { name: "Murrayfield", slug: "murrayfield", country: "Scotland", city: "Edinburgh" },
  { name: "Aviva Stadium", slug: "aviva-stadium", country: "Ireland", city: "Dublin" },
  { name: "Principality Stadium", slug: "principality-stadium", country: "Wales", city: "Cardiff" },
  { name: "Stade de France", slug: "stade-de-france", country: "France", city: "Paris" },
  { name: "Stadio Olimpico", slug: "stadio-olimpico", country: "Italy", city: "Rome" },

  // 🔥 NEW STADIUMS
  { name: "Stade des Alpes", slug: "stade-des-alpes", country: "France", city: "Grenoble" },
  { name: "Dexcom Stadium", slug: "dexcom", country: "Ireland", city: "Galway" },

  /* ===== RUGBY CHAMPIONSHIP ===== */

  { name: "Eden Park", slug: "eden-park", country: "New Zealand", city: "Auckland" },
  { name: "Ellis Park", slug: "ellis-park", country: "South Africa", city: "Johannesburg" },
  { name: "FNB Stadium", slug: "fnb-stadium", country: "South Africa", city: "Johannesburg" },

  /* ===== NEW ZEALAND STADIUMS ===== */
  { 
    name: "HNRY Stadium", 
    slug: "hnry-stadium", 
    country: "New Zealand", 
    city: "Wellington" 
  },
  { 
    name: "One NZ Stadium", 
    slug: "one-nz-stadium", 
    country: "New Zealand", 
    city: "Christchurch" 
  },

  /* ===== SOUTH AFRICA ===== */
  { name: "Cape Town Stadium", slug: "capetown", country: "South Africa", city: "Cape Town" },
];